module.exports = __webpack_public_path__ + "img/zh-flag.b9433b93.svg";